import { VariableType } from 'services/api/api-client';
import { RadioButtonOption } from './VariableTypeSelector';
import { VariableAccessLevel } from '../variable-modal-data';

export const variableTypeOptions: RadioButtonOption[] = [
  { text: VariableType.Manual },
  { text: VariableType.Auto },
];

export const accessLevelOptions: RadioButtonOption[] = [
  { text: VariableAccessLevel.Local },
  { text: VariableAccessLevel.General },
];
